module.exports = __webpack_public_path__ + "img/21.8d8dd7f6.svg";